document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("videoModal");
  const modalVideo = document.getElementById("modalVideo");
  const closeBtn = document.querySelector(".modal-close");

  // Exit early if modal elements don't exist
  if (!modal || !modalVideo) return;

  document.querySelectorAll(".video-card").forEach(card => {
    card.addEventListener("click", () => {
      const videoUrl = card.getAttribute("data-video");
      if (videoUrl) {
        modalVideo.src = videoUrl;
        modal.style.display = "flex";
        document.body.parentElement.style = "overflow: hidden;";
        modalVideo.play();
      }
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      modal.style.display = "none";
      modalVideo.pause();
      modalVideo.src = "";
      document.body.parentElement.style = "overflow: auto;";
    });
  }

  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      modal.style.display = "none";
      modalVideo.pause();
      modalVideo.src = "";
      document.body.parentElement.style = "overflow: auto;";
    }
  });
});